import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * DraggableWaypoint - A sortable waypoint item
 * 
 * Used in WaypointListSection to allow reordering of waypoints
 * within their parent nodes via drag and drop.
 */
export default function DraggableWaypoint({ 
  waypoint, 
  index, 
  stableId, 
  isSelected, 
  isMultiSelected, 
  handleWaypointClick, 
  getProcessTypeColor 
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: stableId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      data-waypoint-index={index}
      className={`p-2 rounded cursor-pointer transition-colors ${
        isSelected ? 'bg-primary bg-opacity-20 border border-primary' :
        isMultiSelected ? 'bg-warning bg-opacity-20' :
        'hover:bg-bg-hover'
      }`}
      onClick={(e) => handleWaypointClick(index, e)}
    >
      <div className="flex items-center gap-2">
        <span
          {...attributes}
          {...listeners}
          className="cursor-grab active:cursor-grabbing px-1 hover:bg-bg-tertiary rounded text-text-secondary"
          onClick={(e) => e.stopPropagation()}
        >
          ⋮⋮
        </span>
        <span
          className="px-2 py-1 rounded text-xs font-semibold text-black"
          style={{ backgroundColor: getProcessTypeColor(waypoint.processType) }}
        >
          {waypoint.number}
        </span>
        <span className="text-text-primary text-sm">{waypoint.processType}</span>
      </div>
      <div className="text-text-secondary text-xs mt-1 ml-6">
        X: {(waypoint.position.x * 1000).toFixed(1)}mm, Y: {(waypoint.position.y * 1000).toFixed(1)}mm, Z: {(waypoint.position.z * 1000).toFixed(1)}mm
      </div>
    </div>
  );
}
